/* eslint-disable max-len */
import React from 'react';
import {AppState} from '../../App';

import './About.scss';

interface AboutProps {
  state: AppState;
}

export default function About({state}: AboutProps) {
  return (
    <div className="About">
      <h1>About</h1>
      <div className="project-description">
        <h2>Project Overview</h2>
        <p>
          The EU-Southeast Asia (EUSEAR) Tracker is part of the &ldquo;European-Southeast Asian relations: their current state and future prospect (EUSEAR)&rdquo; project, funded by the EU NextGenerationEU through the Recovery and Resilience Plan for Slovakia and implemented by CEIAS.
        </p>
        <p>
          The project focuses on the relations between the EU, and in particular the Central European nations, and the Association of Southeast Asian Nations and its members by exploring, how the European-Southeast Asian cooperation can be improved and how both sides can jointly strengthen the regional order in Southeast Asia.
        </p>
        <p>
          Moreover, it analyzes how the EU and ASEAN position themselves amid the geostrategic rivalry of China and the United States in Southeast Asia. A specific research interest is then placed at the Visegrad Four (V4) countries, and notably Slovakia, as well as Austria and their contribution to EU-ASEAN relations, and benefits from closer cooperation.
        </p>
        <p>
          For more details about the project, please visit{' '}
          <a
            href="https://ceias.eu/european-southeast-asian-relations-their-current-state-and-future-prospect-eusear/"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://ceias.eu/european-southeast-asian-relations-their-current-state-and-future-prospect-eusear/
          </a>
        </p>
      </div>
    </div>
  );
}
